import { KfzTypSelectOption } from '@gsm/entities';
import { DYNAMIC_FORM_CONTROL_TYPE_SELECT, MATCH_HIDDEN } from '@ng-dynamic-forms/core';
import { TYPE_COLLISION_PICKER } from '../collision-picker/collision-picker.model';
import { AnyFormControlModel } from '../shared-models/any-form-control.model';

export function GESCHAEDIGTES_FAHRZEUG_TEMPLATE_FACTORY(
  kfzTypesList?: KfzTypSelectOption[],
  descriptionText?: string
): AnyFormControlModel[] {
  return [
    {
      id:            'kfzTyp',
      required:      true,
      label:         'KFZ Typ',
      type:          DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      optionMatcher: ['value'],
      options:       [
        ...(kfzTypesList
          ? kfzTypesList.map(kfzType => ({
            label: kfzType.label,
            value: kfzType
          }))
          : [])
      ],
      errorMessages: {
        required: '{{ label }} ist ein Pflichtfeld.'
      }
    },
    {
      id:            'info',
      type:          'INFO',
      content:       descriptionText || 'Bitte wählen Sie die Kollisionspunkte am gegnerischen Fahrzeug aus.',
      isInstruction: true,
      relations:     [
        {
          match: MATCH_HIDDEN,
          when:  [
            {
              id:    'kfzTyp',
              value: null
            }
          ]
        }
      ]
    },
    {
      id:            'info',
      type:          'INFO',
      content:       '&emsp;&emsp;&emsp;&ensp;&nbsp;Vorne',
      isInstruction: true,
      relations:     [
        {
          match: MATCH_HIDDEN,
          when:  [
            {
              id:    'kfzTyp',
              value: null
            }
          ]
        }
      ]
    },
    {
      id:        'selectedFields',
      type:      TYPE_COLLISION_PICKER,
      relations: [
        {
          match: MATCH_HIDDEN,
          when:  [
            {
              id:    'kfzTyp',
              value: null
            }
          ]
        }
      ]
    },
    {
      id:            'info',
      type:          'INFO',
      content:       '&emsp;&emsp;&emsp;&ensp;Hinten',
      isInstruction: true,
      relations:     [
        {
          match: MATCH_HIDDEN,
          when:  [
            {
              id:    'kfzTyp',
              value: null
            }
          ]
        }
      ]
    }
  ];
}
